import React from 'react'

import SectionHeader from '../components/SectionContent'
import Figure from '../components/Figure'

const lgmIcon = require('../../assets/img/Icon_LGM.svg')
const greenhouseIcon = require('../../assets/img/Icon_Greenhouses.svg')
const warehouseIcon = require('../../assets/img/Icon_Warehouses.svg')
const headerImg = require('../../assets/img/header-img.svg')

const Location = () => (
  <section className="bg-green" id="location">
    <div className="container">
      <SectionHeader
        headerColor="text-gray"
        headerContent="Grow with Confidence"
        subheaderColor="text-white"
        subheaderContent="Farmhand keeps you connected and in control of your growing operation so you always know how it’s running."
      />
      <div className="columns is-space-between" id="places">
        <div className="column">
          <Figure
            figClass="place"
            imgId="lgm-icon"
            imgSrc={lgmIcon}
            imgAlt="Leafy Green Machine Icon"
            capClass="text-gray"
            capContent="Leafy Green Machines"
          />
        </div>
        <div className="column">
          <Figure
            figClass="place"
            imgId="greenhouse-icon"
            imgSrc={greenhouseIcon}
            imgAlt="Greenhouse Icon"
            capClass="text-gray"
            capContent="Greenhouses"
          />
        </div>
        <div className="column">
          <Figure
            figClass="place"
            imgId="lgm-icon"
            imgSrc={warehouseIcon}
            imgAlt="Warehouse Icon"
            capClass="text-gray"
            capContent="Warehouses"
          />
        </div>
      </div>
    </div>
  </section>
)

export default Location



// WEBPACK FOOTER //
// ./containers/Locations.js